<script lang="ts">
    import type {ButtonStyle, ComponentSize} from '../types';
    import type {Placement} from '@floating-ui/core';
    import {Popover, PopoverButton, PopoverPanel} from '@rgossiaux/svelte-headlessui';
    import {exists, uuid as generateUuid} from 'shared/utils/custom-utils';
    import {createFloatingActions} from 'svelte-floating-ui';
    import {offset} from 'svelte-floating-ui/dom';

    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let placement: Placement = 'bottom';
    export let additionalClasses = '';
    export let additionalPopoverClasses = '';
    export let additionalPopoverPanelClasses = '';
    export let additionalPopoverPanelContentClasses = '';
    export let id = generateUuid().toString();

    const buttonClass = `btn-${buttonStyle} btn-${buttonSize}`;
    const [floatingRef, floatingContent] = createFloatingActions({
        placement,
        strategy: 'fixed',
        middleware: [
            offset(10)
        ]
    });
</script>

<Popover class="kp-popover-component {additionalPopoverClasses}" let:open>
    <PopoverButton {id} class="btn {buttonClass} {additionalClasses}" use={[floatingRef]}>
        <slot name="button"></slot>
    </PopoverButton>

    {#if open}
        <div class="kp-popover-panel-container">
            <PopoverPanel focus={true}
                          use={[floatingContent]}
                          class="popover {additionalPopoverPanelClasses}"
                          style="display: block"
                          static>

                <div class="kp-popover-animation-container">
                    {#if exists($$slots['popover-title'])}
                        <div class="popover-title">
                            <slot name="popover-title"/>
                        </div>
                    {/if}

                    <div class="popover-content {additionalPopoverPanelContentClasses}">
                        <slot name="popover-content" {open}/>
                    </div>
                </div>
            </PopoverPanel>
        </div>
    {/if}
</Popover>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .kp-popover-panel-container {
        z-index: @popover-z-index;

        .kp-popover-animation-container {
            animation: 0.3s ease-in-out 0s 1 popover-slide;
        }
    }

    :global {
        .kp-popover-component .popover {
            font-family: unset;
            border-radius: @border-radius-large;
            overflow: hidden;
            padding: 0;
            z-index: @popover-z-index;
        }

        @keyframes popover-slide {
            0% {
                transform: translateY(0.3rem);
                opacity: 0;
            }
            100% {
                transform: translateY(0);
                opacity: 100%;
            }
        }
    }
</style>